import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import AuthProvider from './components/AuthProvider';
import { Toaster } from 'react-hot-toast';

function App({ children }: { children?: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__ || ''}>
        <AuthProvider>
          {children || <AppRoutes />}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
